export const adData = [
  {
    id: 1,
    name: '兵庫県 三田青磁と茶道体験ツアー',
    imageUrl: '三田陶芸の森広告バナー②.png ',
    link: 'https://origamiconcierge.jp/ja/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50',
  },
   {
    id: 2,
    name: 'Hyogo Prefecture: Sanda Celadon and Tea Ceremony Experience Tour',
    imageUrl: '三田陶芸の森広告バナー③.png ',
    link: 'https://origamiconcierge.jp/experience/e716bc13-a93f-4dba-89a0-62e76ee7ff50',
  },
];
